import { For, If, reactive } from 'cdui-js';
import { CheckBoxCard } from '../../../components/CheckBoxCard';
import { showToast } from '../../../components/Toast';
import {
  lastVirtualStep,
  nextVirtualStep,
  OverseasIdentityType,
  virtualApplyState,
} from './store';
import i18n from '../../../../../i18n';
import { addAccountBarPadBottom, addAccountContentReserve } from '../safeAreaBar';

const getOptions = (): { value: OverseasIdentityType; label: string; hint?: string }[] => [
  {
    value: 'HONG_KONG',
    label: i18n.AddAccount.IdHk,
    hint: i18n.AddAccount.IdHkHint,
  },
  {
    value: 'MACAO',
    label: i18n.AddAccount.IdMo,
  },
  {
    value: 'OTHER_REGION',
    label: i18n.AddAccount.IdOther,
  },
];

const SelectOverseasId = () => {
  const state = reactive({
    loading: false,
  });

  return (
    <div>
      <div class="padding-x-L padding-y" style={{ 'margin-bottom': `${addAccountContentReserve(140)}px` }}>
        <div class="font-s color-D font-bold margin-b-L">{i18n.AddAccount.SelectIdTitle}</div>

        <div class="flex flex-column gap-12px">
          <For each={getOptions()}>
            {(item) => (
              <CheckBoxCard
                active={virtualApplyState.overseasIdentityType === item.value}
                onclick={() => (virtualApplyState.overseasIdentityType = item.value)}
                class="round-XL"
                showBadge={false}
                activeBorderColor="var(--text-1)"
              >
                <div class="padding-x-L flex flex-column justify-center" style={{ height: '78px' }}>
                  <div class="color-D font-s leading-20px">{item.label}</div>
                  <If when={!!item.hint}>
                    <div class="font-s-S color-L" style={{ 'line-height': '1.4' }}>
                      {item.hint}
                    </div>
                  </If>
                </div>
              </CheckBoxCard>
            )}
          </For>
        </div>
      </div>

      <div
        class="fixed position-b position-l width-100 bg-c padding-x-L flex gap-8px"
        style={{
          'padding-top': '12px',
          'padding-bottom': `${addAccountBarPadBottom(16)}px`,
          'z-index': 150,
        }}
      >
        <button
          class="default-btn btn-rounded"
          style={{ flex: 1 }}
          onclick={() => lastVirtualStep()}
          disabled={state.loading}
        >
          {i18n.OpenProgress.Common.Prev}
        </button>
        <button
          class="confirm-btn btn-rounded"
          style={{ flex: 2 }}
          onclick={() => {
            if (!virtualApplyState.overseasIdentityType) {
              showToast(i18n.AddAccount.ToastSelectId);
              return;
            }
            nextVirtualStep();
          }}
          disabled={state.loading}
        >
          {i18n.OpenProgress.Common.Next}
        </button>
      </div>
    </div>
  );
};

export default SelectOverseasId;
